// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/components/DataQueues/EventDialogServiceTimeSidebar/PaymentLabels.js

import React from 'react';

import { useState, useEffect } from 'react';
import { getSelectedLanguage } from '../../../api/api';
import { languageManager } from '../../../utils/loadLanguage';

const PaymentLabels = () => {
  const [translations, setTranslations] = useState({});
  useEffect(() => {
    async function loadLang() {
      const lang = getSelectedLanguage();
      await languageManager.loadLanguage(lang);
      setTranslations(languageManager.translations);
    }
    loadLang();
  }, []);

  return (
    <>

      <div className="p-field-horizontal">
        <label htmlFor="visa" className="payment-label">{translations.paymentLabels?.label_visa || "Visa"}</label>
      </div>
      <div className="p-field-horizontal">
        <label htmlFor="payCash" className="payment-label">{translations.paymentLabels?.label_payCash || "Pay Cash"}</label>
      </div>
      <div className="p-field-horizontal">
        <label htmlFor="qrCode" className="payment-label">{translations.paymentLabels?.label_qrCode || "QR-Code"}</label>
      </div>
    </>
  );
};

export default PaymentLabels;
